import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function CssFilterGenerator() {
  // State for all CSS filter properties
  const [brightness, setBrightness] = useState(100);
  const [contrast, setContrast] = useState(100);
  const [saturate, setSaturate] = useState(100);
  const [grayscale, setGrayscale] = useState(0);
  const [sepia, setSepia] = useState(0);
  const [invert, setInvert] = useState(0);
  const [blur, setBlur] = useState(0);
  const [hueRotate, setHueRotate] = useState(0);

  // Compose CSS filter string
  const cssFilter = `
    brightness(${brightness}%)
    contrast(${contrast}%)
    saturate(${saturate}%)
    grayscale(${grayscale}%)
    sepia(${sepia}%)
    invert(${invert}%)
    blur(${blur}px)
    hue-rotate(${hueRotate}deg)
  `.replace(/\s+/g, " ").trim();

  // Copy CSS filter to clipboard
  const copyToClipboard = () => {
    navigator.clipboard.writeText(`filter: ${cssFilter};`);
    alert("CSS Filter copied to clipboard!");
  };

  return (
    <>
      <Helmet>
        <title>CSS Filter Generator - Free Online Tool</title>
        <meta
          name="description"
          content="Generate CSS filter effects like brightness, contrast, saturate, grayscale, sepia, invert, blur, and hue-rotate online with live preview and copy CSS code."
        />
        <meta
          name="keywords"
          content="css filter generator, brightness css filter, contrast filter css, blur css, saturate css filter, online css filters"
        />
        <link rel="canonical" href="https://https://freelity.com/css-filter-generator" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />

          <h2>CSS Filter Generator</h2>
          <p>Adjust the sliders to create CSS filter effects and copy the generated CSS code.</p>

          <div className="row">
            <div className="col-md-6">
              {/* Controls */}
              <div className="mb-3">
                <label className="form-label">
                  Brightness: {brightness}%
                </label>
                <input
                  type="range"
                  min="0"
                  max="200"
                  value={brightness}
                  onChange={(e) => setBrightness(e.target.value)}
                  className="form-range"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Contrast: {contrast}%
                </label>
                <input
                  type="range"
                  min="0"
                  max="200"
                  value={contrast}
                  onChange={(e) => setContrast(e.target.value)}
                  className="form-range"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Saturate: {saturate}%
                </label>
                <input
                  type="range"
                  min="0"
                  max="300"
                  value={saturate}
                  onChange={(e) => setSaturate(e.target.value)}
                  className="form-range"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Grayscale: {grayscale}%
                </label>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={grayscale}
                  onChange={(e) => setGrayscale(e.target.value)}
                  className="form-range"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Sepia: {sepia}%
                </label>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={sepia}
                  onChange={(e) => setSepia(e.target.value)}
                  className="form-range"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Invert: {invert}%
                </label>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={invert}
                  onChange={(e) => setInvert(e.target.value)}
                  className="form-range"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Blur: {blur}px
                </label>
                <input
                  type="range"
                  min="0"
                  max="10"
                  step="0.1"
                  value={blur}
                  onChange={(e) => setBlur(e.target.value)}
                  className="form-range"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Hue-Rotate: {hueRotate}°
                </label>
                <input
                  type="range"
                  min="0"
                  max="360"
                  value={hueRotate}
                  onChange={(e) => setHueRotate(e.target.value)}
                  className="form-range"
                />
              </div>

              <button className="btn btn-success mt-3" onClick={copyToClipboard}>
                Copy CSS Filter Code
              </button>
            </div>

            <div className="col-md-6 d-flex flex-column align-items-center justify-content-center">
              <div
                className="preview-box"
                style={{
                  filter: cssFilter,
                  width: "320px",
                  height: "200px",
                  background:
                    "url('https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=320&q=80') center/cover no-repeat",
                  borderRadius: "8px",
                  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                }}
              >
                <span
                  style={{
                    color: "#fff",
                    textShadow: "1px 1px 4px rgba(0,0,0,0.7)",
                    padding: "6px",
                    display: "block",
                    fontWeight: "600",
                    textAlign: "center",
                  }}
                >
                  Preview
                </span>
              </div>

              <textarea
                readOnly
                className="form-control mt-3"
                rows="3"
                value={`filter: ${cssFilter};`}
              />
            </div>
          </div>

          
        </div>
      </section>
    </>
  );
}
